@import "stylesheets/sdx/typography/typography";
@import "stylesheets/sdx/utilities/bg-color";

$spacing-to-window-mobile: 0px;
$spacing-to-window-desktop: $baseline * 8;
$spacing-to-top-mobile: $baseline-6;
$spacing-with-close-button: 46px; // 10px icon-position-right + 24px icon-size + 12px space

@mixin max-height() {
  max-height: calc(
    var(--sdx-dialog-window-inner-height, 100vh) - #{$spacing-to-window-mobile} -
      #{$spacing-to-top-mobile}
  );

  @include bp-sm {
    max-height: calc(
      var(--sdx-dialog-window-inner-height, 100vh) - #{$spacing-to-window-desktop}
    );
  }
}

@mixin horizontal-paddings() {
  padding-left: $baseline-2;
  padding-right: $baseline-2;

  @include bp-lg {
    padding-left: $baseline-3;
    padding-right: $baseline-3;
  }
}

// just set width in case no col-* class is set
:host(:not([class*="col-"])) {
  .component {
    // on mobiles always stretch to full width
    width: calc(100vw - #{$spacing-to-window-mobile});

    @include bp-sm {
      width: auto;
    }
  }
}

:host {
  display: none;

  // "!important" needed to overwrite col-* styles
  padding-left: $spacing-to-window-mobile * 0.5 !important;
  padding-right: $spacing-to-window-mobile * 0.5 !important;

  @include bp-sm {
    padding-left: $spacing-to-window-desktop * 0.5 !important;
    padding-right: $spacing-to-window-desktop * 0.5 !important;
  }
}

.component {
  background-color: white;
  box-shadow: 0 0 4px rgba($color-black, 0.2);
  min-height: max(300px, 30vh);
  border-radius: $border-radius-large $border-radius-large 0 0;

  &.fixed-height {
    // workaround to avoid soft keyboards to overlap, see SDX-1461
    min-height: 70vh; // measured with an iPad Air in landscape
  }

  @include bp-sm {
    border-radius: $border-radius-large;
    min-height: unset;
    min-width: 436px; // from figma
  }

  .content-wrapper {
    position: relative; // for .close-button
    display: flex;
    flex-direction: column;
    gap: $baseline-2;
    @include max-height();
    // just set vertical paddings to have correct scrollbar position on .slot
    padding-top: $baseline-3;
    padding-bottom: $baseline-3;

    .close-button {
      position: absolute;
      top: $spacing-close-button;
      right: $spacing-close-button;
      z-index: 1;

      ~ .header:not(.align-header-center.has-icon) {
        // Add padding because of the closing button when:
        // - header is not centered
        // - header is centered and has no icon
        padding-right: $spacing-with-close-button;
      }

      // add padding-left to center label
      ~ .align-header-center:not(.has-icon) {
        padding-left: $spacing-with-close-button;
      }
    }

    .header {
      display: flex;
      color: $color-navy;
      gap: $baseline-2;
      @include horizontal-paddings();

      &.alert {
        color: $color-int-red;
      }

      &.warning {
        color: $color-int-orange;
      }

      &.general {
        color: $color-int-blue;
      }

      &.confirmation {
        color: $color-int-green;
      }

      &.align-header-center {
        flex-direction: column;
        align-items: center;
      }

      &:not(.align-header-center) {
        .icon {
          align-self: center;
          font-size: $icon-s2;

          @include bp-desktop {
            font-size: $icon-s3;
          }
        }
      }

      .h3 {
        @include line-clamp(2);
        margin-bottom: 0;
        color: $color-sc-navy;
      }
    }

    .slot {
      position: relative; // position outlets correctly (if any)
      overflow-y: auto;
      @include horizontal-paddings();
    }
  }
}

.component.sdx--dark-theme {
  background-color: $color-dusk-tint-4-dark-theme;

  .header {
    color: $color-gray-dark-theme;

    &.alert {
      color: $color-int-red-dark-theme;
    }

    &.warning {
      color: $color-int-orange-dark-theme;
    }

    &.general {
      color: $color-int-blue-dark-theme;
    }

    &.confirmation {
      color: $color-int-green-dark-theme;
    }

    .h3 {
      color: $color-gray-dark-theme;
    }
  }
}
